import { Spin } from 'antd';
import React from 'react';

interface LoaderType {
    loaderMessage?: string;
    size?: 'default' | 'large' | 'small';
    style?: React.CSSProperties;
    'data-testid'?: string;
}

const Loader = ({ size = 'default', loaderMessage = '', style = {}, 'data-testid': dataTestId }: LoaderType) => {
    return (
        <div
            style={style}
            data-testid={dataTestId}
            className="min-h-full flex justify-center items-center w-full"
        >
            <Spin size={size} tip={loaderMessage} />
        </div>
    );
};

export default Loader;
